import { Star, Quote } from 'lucide-react';
import AnimateIn from './AnimateIn';

const testimonials = [
  {
    id: 'landlord-1',
    quote: 'ActCheck has completely changed how I manage compliance across my properties. I never miss a deadline now.',
    name: 'James P.',
    role: 'Self-managing landlord',
    rating: 5,
  },
  {
    id: 'tenant-1',
    quote: "I finally understand what documents I should have received and what my rights are. It's all in one place.",
    name: 'Sarah K.',
    role: 'Tenant',
    rating: 5,
  },
  {
    id: 'landlord-2',
    quote: 'Managing five properties used to mean spreadsheets and sticky notes. ActCheck keeps everything organised and evidence-ready.',
    name: 'David M.',
    role: 'Portfolio landlord',
    rating: 5,
  },
];

function TestimonialCard({ testimonial, index }) {
  return (
    <AnimateIn delay={index * 120}>
      <div
        data-testid={`testimonial-card-${testimonial.id}`}
        className="group bg-white rounded-2xl p-7 h-full shadow-sm border border-gray-100 hover:shadow-lg hover:border-compliance-green/20 hover:-translate-y-1 transition-all duration-300 relative overflow-hidden"
      >
        <div className="absolute top-0 left-0 right-0 h-1 actcheck-gradient opacity-0 group-hover:opacity-100 transition-opacity duration-300" />
        <div className="flex items-center gap-0.5 mb-4">
          {Array.from({ length: testimonial.rating }).map((_, j) => (
            <Star key={`star-${testimonial.id}-${j}`} size={14} className="fill-compliance-green text-compliance-green" />
          ))}
        </div>
        <Quote size={20} className="text-compliance-green/20 mb-3" />
        <p className="font-body text-sm text-ink/80 leading-relaxed mb-6">"{testimonial.quote}"</p>
        <div className="mt-auto">
          <p className="font-heading font-bold text-sm text-ink">{testimonial.name}</p>
          <p className="font-body text-xs text-slate-text">{testimonial.role}</p>
        </div>
      </div>
    </AnimateIn>
  );
}

export default function TestimonialsSection() {
  return (
    <section data-testid="testimonials-section" className="py-20 sm:py-28 bg-mist">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <AnimateIn>
          <div className="text-center mb-14">
            <span className="inline-block text-compliance-green font-body font-semibold text-sm tracking-wide uppercase mb-3">
              Testimonials
            </span>
            <h2 className="font-heading font-bold text-3xl sm:text-4xl text-ink mb-4">
              Trusted by landlords and tenants
            </h2>
            <p className="text-slate-text font-body text-lg max-w-2xl mx-auto">
              See how ActCheck helps people stay organised, compliant, and protected.
            </p>
          </div>
        </AnimateIn>
        <div className="grid md:grid-cols-3 gap-6">
          {testimonials.map((t, i) => (
            <TestimonialCard key={t.id} testimonial={t} index={i} />
          ))}
        </div>
      </div>
    </section>
  );
}
